import React from "react";
import "./index.scss";
const PacketStatBox = (
	{
		label = '',
		value = '',
		iconColor = ''
	}
) => {
	return (
		<>
			<div className="packet-stats-box d-inline-flex align-items-center">
				<div className={`icon d-inline-flex align-items-center justify-content-center ${iconColor}`}>
					<img className="img-fluid" src={require('../../../../../assets/img/icons/bar-line.svg')} alt="line" />
				</div>
				<div className="info">
					<h2>{label}</h2>
					<h3>{value}</h3>
				</div>
			</div>
		</>
	);

}
export default PacketStatBox;